import React from 'react';
import PropTypes from 'prop-types';
import Collapse, {Panel} from 'rc-collapse';
import BookingStep from './BookingStep';
import Tickets from './Tickets';
import FocusableTrigger from './FocusableTrigger';
import Translate from './Translate';
import {getTicketGroupName} from '../api/utils';
import TicketsHOC from '../hoc/TicketsHOC';

const TicketPanels = ({
  ticketGroups, onChange, stepIndex, stepTotal,
}) => {
  const panels = Object.keys(ticketGroups)
    .map((index) => {
      const tickets = ticketGroups[index];
      const panelHeader = (
        <div className="ticket">
          <div className="ticket__header">
            <div className="ticket__image">
              <img src={`https://image.novasol.com/site/_img/logos/ticketgroups/activities_${index}.jpg`} />
            </div>
            <h3 className="ticket__title">{getTicketGroupName(index)}</h3>
            <FocusableTrigger
              className="ticket__button"
            >
              <Translate content="Show tickets" />
              <i aria-hidden="true" className="fa fa-angle-down" />
            </FocusableTrigger>
          </div>
        </div>
      );
      return (
        <Panel header={panelHeader} key={index}>
          <Tickets onChange={onChange} tickets={tickets} />
        </Panel>
      );
    });
  return (
    <section className="booking-step booking-extras card" id="booking-extras">
      <div className="booking-step__inner">
        <div className="booking-step__inner2">
          <h2 className="card__header">
            <span className="card__header-prefix">
{stepIndex}
/
{stepTotal}
            </span>
            <Translate content="Attractions and Deals" />
          </h2>
          <section className="card__body" id="extra">
            <Collapse accordion={false}>
              {panels}
            </Collapse>
          </section>
        </div>
      </div>
    </section>
  );
};

TicketPanels.PropTypes = {
  ticketGroups:PropTypes.object.isRequired,
  onChange:PropTypes.func.isRequired,
  stepIndex:PropTypes.number.isRequired,
  stepTotal:PropTypes.number.isRequired,
};

export default TicketsHOC(BookingStep(TicketPanels));
